import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedBankIdState {
  selectedBankId: string | null;
  searchParams: string | null;
  id: string | null;
  group_type: string | null;
  group: string | null;
  listOfBankAccountsUrl: string | null;
  listOfBankTransactionsUrl: string | null;
  listOfBalanceSheetUrl: string | null;
  listOfUsers: string | null;
}

const initialState: SelectedBankIdState = {
  selectedBankId: null,
  searchParams: null,
  id: null,
  group_type: null,
  group: null,
  listOfBankAccountsUrl: null,
  listOfBankTransactionsUrl: null,
  listOfBalanceSheetUrl: null,
  listOfUsers: null,
};

const selectedBankIdSlice = createSlice({
  name: 'selectedBankId',
  initialState,
  reducers: {
    setSelectedBankId(state, action: PayloadAction<string>) {
      state.selectedBankId = action.payload;
    },
    clearSelectedBankId(state) {
      state.selectedBankId = null;
    },
    setPersistedParams(state, action: PayloadAction<Partial<Omit<SelectedBankIdState, 'selectedBankId'>>>) {
      return { ...state, ...action.payload };
    },
    clearPersistedParams(state) {
      state.searchParams = null;
      state.id = null;
      state.group_type = null;
      state.group = null;
    },
    setListOfBankAccountsUrl: (state, action) => {
      state.listOfBankAccountsUrl = action.payload;
    },
    setListOfBankTransactionsUrl: (state, action) => {
      state.listOfBankTransactionsUrl = action.payload;
    },
    setListOfBalanceSheetUrl: (state, action) => {
      state.listOfBalanceSheetUrl = action.payload;
    },
    setListOfUsers: (state, action) => {
      state.listOfUsers = action.payload;
    },
  },
});

export const { setSelectedBankId, clearSelectedBankId, setPersistedParams, clearPersistedParams, setListOfBankAccountsUrl, setListOfBankTransactionsUrl, setListOfBalanceSheetUrl, setListOfUsers } = selectedBankIdSlice.actions;
export default selectedBankIdSlice.reducer; 